import type { AxiosInstance, AxiosResponse } from 'axios';

import { createApiRequestConfig, transformApiResponseData } from '../utilities/api_case';
import instantSurveyApi from './api';

const axios = instantSurveyApi as AxiosInstance;

export interface DidYouKnowEntry {
  description: string;
  headline: string;
  id: number;
  isLinked: boolean;
  learnMoreUrl: null | string;
  title: string;
}

interface DidYouKnowResponse {
  count: number;
  next: null | string;
  previous: null | string;
  results: DidYouKnowEntry[];
}

interface DidYouKnowResponsePayload extends Omit<DidYouKnowResponse, 'results'> {
  results: Array<
    Omit<DidYouKnowEntry, 'isLinked' | 'learnMoreUrl'> & {
      is_linked: boolean;
      learn_more_url: null | string;
    }
  >;
}

export const readVisibleDidYouKnowEntries = async ({
  signal,
}: { signal?: AbortSignal } = {}): Promise<DidYouKnowEntry[]> => {
  const entries: DidYouKnowEntry[] = [];
  let offset = 0;
  let hasNextPage = true;

  while (hasNextPage) {
    const { data } = (await axios(
      createApiRequestConfig({
        method: 'get',
        params: { isVisible: true, limit: 100, offset },
        signal,
        url: '/instantsurvey/did_you_know',
      })
    )) as AxiosResponse<DidYouKnowResponsePayload>;

    const page = transformApiResponseData(data);
    entries.push(...page.results);
    hasNextPage = Boolean(page.next);
    offset += page.results.length;
  }

  return entries;
};
